$(document).ready(function () {
  // Prepend General Message Banner to Header
  $('.generalmessage').prependTo('header');

  // ========================
  // DROPDOWN SCRIPTS 
  // ========================
  const dropdownContainer = $('.mobile-menu-container');

  // Search Bar Script
  $('.searchBoxInput input').attr('placeholder', 'Search Website');
  $('.searchBoxInput input').val('');
  $(dropdownContainer).find('.search-container').attr('placeholder', 'Search Website');
  $('#mobileSearchInput').val('');
  $('.header .emailSignup .emailInputSubmit .button').text('');

  // Dropdown script for ticket button and containers
  $('.mobile-menu-footer-links').empty();
  $(dropdownContainer).append('<div class="dropdown-wrap"></div>');
  $(dropdownContainer).find('.mobile-menu-slider').appendTo('.dropdown-wrap');
  $(dropdownContainer).find('.mobile-menu-footer-links').appendTo('.dropdown-wrap');
  $(dropdownContainer).find('.mobile-menu-header').append('<div class="inner-container"></div>');
  $('.header .ticket-container').clone().appendTo('.mobile-menu-container .inner-container');
  $(dropdownContainer).find('.close-mobile-menu').appendTo('.mobile-menu-container .inner-container');
  $('.header-logo').clone().appendTo('.mobile-menu-container .inner-container');
  $('<div class="top-header-mobile"></div>').prependTo('.mobile-menu-container');
  $('.login-status-link').clone().appendTo('.mobile-menu-container .top-header-mobile');

  // Mobile menu toggle
  $('.mobile-nav-toggle').append('<div></div><div></div><div></div>')
  $('.mobile-nav-toggle').on('click', () => {
    $(dropdownContainer).find('.mobile-menu-slider .m-group').each(function () {
      $(this).find('.next-level-btn').empty();
    })
    $('.mobile-menu-slider').css('height', 'auto')
  });



  // ========================
  // MISC SCRIPTS 
  // ========================
  $(window).load(function () {
    $('.header .navMobileMenuShiftedGoBack').remove();
  })
});

